import styled from 'styled-components';
import CalciteTheme from '../CalciteTheme';

export const getControlStyles = (isFocused?: boolean) => ({
  border: `1px solid ${CalciteTheme.color.borderInput}`,
  borderRadius: '0px',
  minHeight: '32px',
  lineHeight: 'normal',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: CalciteTheme.color.foreground2
  },
  ...(isFocused
    ? {
        border: `1px solid ${CalciteTheme.color.brandHover}`,
        boxShadow: `none`
      }
    : {})
});

export const DropdownIndicatorContainer = styled.div`
  height: 1rem;
  width: 1rem;
  padding: 0 0.75rem;
`;

export const DropdownIndicatorPath = styled.path.attrs({
  d: 'M8 11.207l-4-4V5.793l4 4 4-4v1.414z'
})``;

export const DropdownIndicatorStyles = {
  padding: '6px',
  color: CalciteTheme.color.text2
};

export const DropdownIndicatorSvg = styled.svg.attrs(({ theme }) => ({
  fill: theme.color.text2,
  height: '100%',
  viewBox: '0 0 16 16',
  width: '100%',
  xmlns: 'http://www.w3.org/2000/svg'
}))``;

export const FormatOptionContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const IndicatorSeparatorStyles = {
  backgroundColor: `${CalciteTheme.color.borderInput}`
};

export const MenuListStyles = {
  padding: '0'
};

export const MenuStyles = {
  borderRadius: 0,
  margin: 0,
  // https://github.com/JedWatson/react-select/issues/4201#issuecomment-874098561
  width: 'max-content',
  minWidth: '100%'
};

export const MenuPortalStyles = {
  zIndex: 701,
  lineHeight: 'normal'
};

export const OptionFocusedStyles = {
  backgroundColor: CalciteTheme.color.foreground3
};

export const OptionSelectedStyles = {
  backgroundColor: CalciteTheme.color.foreground2,
  borderInlineStart: `3px solid ${CalciteTheme.color.brand}`
};

export const OptionStyles = {
  height: '32px',
  color: CalciteTheme.color.text1,
  fontSize: '14px',
  cursor: 'pointer',
  whiteSpace: 'nowrap' as const,
  '&:hover': {
    backgroundColor: CalciteTheme.color.foreground3
  }
};

export const PlaceholderStyles = {
  color: `${CalciteTheme.color.text2}`
};

export const SubtitleContainer = styled.div`
  margin-inline-start: auto;
  color: ${({ theme }) => theme.color.text3};
`;

export const ValueContainerStyles = {
  fontSize: '14px'
};
